module.exports = __webpack_public_path__ + "static/media/jamon.df48fa9c.png";